import React, { useState } from "react";
import Rating from "react-rating";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";

const TicketRatingsCard = ({
  rated,
  onSubmitRating,
  TicketDetail,
  RatingRemarks,
  CurrentStatus,
}) => {
  const [userRating, setUserRating] = useState(0);
  const [userRemarks, setUserRemarks] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleFeedbackClick = () => {
    if (CurrentStatus?.toLowerCase() === "done") {
      setAlertMessage(""); // clear previous alerts
      setModalOpen(true);
    } else {
      setAlertMessage("Feedback can only be submitted when the status is 'Done'.");
    }
  };

  const handleSubmit = () => {
    if (userRating > 0) {
      onSubmitRating(userRating, userRemarks);
      setModalOpen(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <i className="ri-star-fill align-bottom me-1 text-warning"></i>
            <h5
              className="card-title mb-0"
              style={{ fontWeight: 700, fontSize: "15px" }}
            >
              Acknowledgement
            </h5>
          </div>
          {!rated && (
            <Button color="warning" size="sm" onClick={handleFeedbackClick}>
              Feedback
            </Button>
          )}
        </div>
      </CardHeader>

      <CardBody>
        {alertMessage && (
          <Alert color="danger" className="py-2">
            {alertMessage}
          </Alert>
        )}

        {RatingRemarks && Object.keys(TicketDetail).length > 0 ? (
          <div className="mb-2">
            {Object.keys(TicketDetail).map((key) => (
              <p key={key} className="mb-1">
                <strong>{key}:</strong> {TicketDetail[key]}
              </p>
            ))}
          </div>
        ) : (
          <p className="text-muted mb-0">No details available.</p>
        )}

        {rated && (
          <p className="text-success mt-2">Thank you for your feedback!</p>
        )}
      </CardBody>

      {/* Feedback Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Submit Feedback</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <h6 className="mb-2">Give Your Rating</h6>
            <Rating
              initialRating={userRating}
              onClick={(rate) => setUserRating(rate)}
              fractions={2}
              emptySymbol="mdi mdi-star-outline text-muted"
              fullSymbol="mdi mdi-star text-warning"
              style={{ fontSize: "30px" }}
            />

            <FormGroup className="mt-3">
              <Label for="remarks">Remarks</Label>
              <Input
                type="textarea"
                id="remarks"
                value={userRemarks}
                onChange={(e) => setUserRemarks(e.target.value)}
                placeholder="Enter your remarks here..."
                rows="3"
              />
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            onClick={handleSubmit}
            disabled={userRating === 0}
          >
            Submit
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default TicketRatingsCard;
